<article [attr.data-name]="name">
  @if (route) {
    <a [routerLink]="[route]" matTooltip="{{ 'commons.btn.navigate' | translate }}" class="stat-box-link">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </a>
  } @else if (href) {
    <a [href]="href" matTooltip="{{ 'commons.btn.navigate' | translate }}" class="stat-box-link">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </a>
  } @else {
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  }
</article>

<ng-template #content>
  <section [class]="color ? 'colored ' + color : ''">
    <mat-icon>{{ icon }}</mat-icon>
  </section>
  <section>
    @if (hasStat) {
      @if (!loading) {
        <span class="stat">{{ stat }}</span>
      } @else {
        <app-loader [formField]="true"></app-loader>
      }
    }
    @if (text) {
      <span class="description">{{ text | translate }}</span>
    }
  </section>
</ng-template>
